const carRental = {
  carRental: "Aluguel de carros", // translated
  carRentals: "Aluguel de carros", // translated
  pickUpPoint: "Ponto de coleta", // translated
  dropOffPoint: "Ponto de entrega", // translated
  pickUpDate: "Data de retirada", // translated
  dropOffDate: "Data de entrega", // translated
  pickUp: "Escolher", // translated
  dropOff: "Deixar", // translated
  edit: "Editar", // translated
  fuelPolicy: "Política de Combustível", // translated
  pickUpLocation: "Local de retirada", // translated
  mileage: "Quilometragem", // translated
  transmission: "Transmissão", // translated
  airCondition: "Condição do ar", // translated
  minimumAge: "Idade minima", // translated
  maximumAge: "Idade Máxima", // translated
  providerAddress: "Endereço do provedor", // translated
  providerPhone: "Telefone do provedor", // translated
  driverInfo: "Informações do motorista", // translated
  driversInfo: "Informações do motorista", // translated
  differentDropOff: "Entrega em local diferente", // translated
  maxPassengers: "Máximo de passageiros", // translated
  budget: "Orçamento", // translated
  provider: "Fornecedor", // translated
  carModel: "Modelo de carro", // translated
  numOfDoors: "Número de portas", // translated
  fuelType: "Tipo de combustível", // translated
  driverAge: "Idade do motorista", // translated
  workingHours: "Jornada de trabalho", // translated
  driverNationality: "Nacionalidade do Motorista", // translated
  carRentalRate: "Taxa de aluguel de carro", // translated
  dueNow: "Vencimento agora", // translated
  duePickUp: "Vencimento na retirada", // translated
  toViewOfferPDF: "Para visualizar um documento PDF contendo todos os termos de aluguel desta oferta, por favor", // translated
  toViewTermsAndCondPDF: "Para visualizar os Termos e Condições CARNECT aplicáveis, por favor", // translated
};

export default carRental;
